module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_sekundaerlogo_postale_neg.38891b85.png";